<template>
  <div>
    <b-row class="no-gutters">
      <b-col>
        <h1 class="font-weight-bold header-main text-uppercase mb-3">
          ข้อมูลแถบประกาศ
        </h1>
      </b-col>
    </b-row>
    <div class="bg-white p-3" v-if="$isLoading">
      <b-row class="mt-2">
        <b-col>
          <InputText
            textFloat="ชื่อแถบประกาศ"
            placeholder="ชื่อแถบประกาศ"
            type="text"
            name="name"
            v-model="form.name"
            isRequired
            :isValidate="$v.form.name.$error"
            :v="$v.form.name"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <InputTextArea
            rows="4"
            textFloat="ข้อความในประกาศ"
            placeholder="ข้อความในประกาศ"
            type="text"
            name="desc"
            v-model="form.message"
            isRequired
            :isValidate="$v.form.message.$error"
            :v="$v.form.message"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <DateTimePicker
            textFloat="วันเริ่มต้น"
            type="datetime"
            isTime
            isRequired
            placeholder="กรุณาเลือกวันที่และเวลา"
            v-model="form.startDate"
            :isValidate="$v.form.startDate.$error"
            :v="$v.form.startDate"
          />
        </b-col>
        <b-col md="6">
          <DateTimePicker
            textFloat="วันสิ้นสุด"
            type="datetime"
            isTime
            isRequired
            placeholder="กรุณาเลือกวันที่และเวลา"
            v-model="form.endDate"
            :isValidate="$v.form.endDate.$error"
            :v="$v.form.endDate"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <ColorPicker
            textFloat="Background Color"
            v-model="form.backgroundColor"
            :value="form.backgroundColor"
            name="primary_color"
            :isValidate="$v.form.backgroundColor.$error"
            :v="$v.form.backgroundColor"
            isRequired
          />
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col>
          <label class="font-weight-bold main-label">
            สถานะการแสดงผล
            <span class="text-danger">*</span>
          </label>
          <div>
            <b-form-checkbox
              switch
              v-model="form.display"
              class="radio-active"
              size="lg"
            >
              <span class="ml-2 main-label">{{
                form.display ? "ใช้งาน" : "ไม่ใช้งาน"
              }}</span>
            </b-form-checkbox>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col md="6">
          <b-button
            v-if="isEdit"
            class="btn btn-danger btn-details-set mr-md-2"
            :disabled="isDisable"
            @click="openModalDelete(form.name)"
            >ลบ</b-button
          >
          <router-link to="/announcement">
            <b-button :disabled="isDisable" class="btn-details-set btn-cancel"
              >ย้อนกลับ</b-button
            >
          </router-link>
        </b-col>
        <b-col md="6" class="text-sm-right">
          <button
            type="button"
            @click="checkForm(0)"
            :disabled="isDisable"
            class="btn btn-main btn-details-set ml-md-2 text-uppercase"
          >
            บันทึก
          </button>
          <button
            type="button"
            @click="checkForm(1)"
            :disabled="isDisable"
            class="btn btn-main btn-details-set ml-md-2 text-uppercase"
          >
            บันทึกและออก
          </button>
        </b-col>
      </b-row>
    </div>
    <ModalAlert ref="modalAlert" :text="modalMessage" />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalAlertConfirm
      msg="ยืนยันการลบ ?"
      :text="modalMessage"
      btnConfirm="ลบ"
      colorBtnConfirm="danger"
      btnCancel="ยกเลิก"
      ref="isModalAlertConfirm"
      @confirm="btnDelete"
    />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputTextArea from "@/components/inputs/InputTextArea";
import DateTimePicker from "@/components/inputs/DateTimePicker";
import ColorPicker from "@/components/inputs/ColorPicker";
import { required } from "vuelidate/lib/validators";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalLoading from "@/components/modal/alert/ModalLoading";

const minDate = (value, fromDate) => {
  if (!value) return true;
  let minDate = fromDate;
  return new Date(value) > new Date(minDate);
};
const maxDate = (value, toDate = null) => {
  let maxDate = toDate || new Date();
  return new Date(maxDate) > new Date(value);
};

export default {
  name: "AnnouncementDetails",
  components: {
    InputText,
    InputTextArea,
    DateTimePicker,
    ColorPicker,
    ModalAlert,
    ModalAlertError,
    ModalAlertConfirm,
    ModalLoading,
  },
  data() {
    return {
      id: this.$route.params.id ?? 0,
      isEdit: false,
      modalMessage: "",
      isDisable: false,
      modalAlertShow: false,
      flag: false,
      form: {
        id: this.$route.params.id ?? 0,
        name: "",
        message: "",
        backgroundColor: "",
        startDate: "",
        endDate: "",
        display: false,
      },
    };
  },
  validations() {
    return {
      form: {
        name: { required },
        message: { required },
        backgroundColor: { required },
        startDate: {
          required,
          maxDateTime(val, { endDate }) {
            return maxDate(val, endDate);
          },
        },
        endDate: {
          required,
          minDateTime(val, { startDate }) {
            return minDate(val, startDate);
          },
        },
      },
    };
  },
  created: async function () {
    await this.getDatas();
  },
  methods: {
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getDatas: async function () {
      this.$isLoading = false;
      let data = await this.$callApi(
        "get",
        `${this.$baseUrl}/api/announcement/${this.id}`,
        null,
        this.$headers,
        null,
      );

      if (data.result == 1) {
        this.form = data.detail;

        this.form.startDate = `${data.detail.startDate.split(" ")[0]}T${
          data.detail.startDate.split(" ")[1]
        }.000+07:00`;
        this.form.endDate = `${data.detail.endDate.split(" ")[0]}T${
          data.detail.endDate.split(" ")[1]
        }.000+07:00`;

        this.$v.form.$reset();

        if (this.id > 0) {
          this.isEdit = true;
        }
      }

      this.$isLoading = true;
    },
    checkForm: async function (flag) {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;
      this.modalAlertShow = false;
      this.flag = flag;
      this.submit();
    },
    submit: async function () {
      this.isDisable = true;
      this.$refs.modalLoading.show();

      let data = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/announcement/save`,
        null,
        this.$headers,
        this.form,
      );

      this.modalMessage = data.message;
      this.isDisable = false;
      this.$refs.modalLoading.hide();

      if (data.result == 1) {
        this.existId = data.detail;
        this.modalMessage = "สำเร็จ";
        this.$refs.modalAlert.show();

        if (this.flag == 1) {
          setTimeout(() => {
            this.$router.push({
              path: `/announcement`,
            });
          }, 3000);
        } else {
          setTimeout(() => {
            this.$refs.modalAlert.hide();
          }, 3000);
          if (this.id > 0) {
            this.getDatas();
          } else {
            this.form.id = this.existId;
            this.id = this.existId;
            this.isEdit = true;
            this.$router.push({
              path: `/announcement/details/${this.existId}`,
            });
          }
        }
      } else {
        this.$refs.modalAlertError.show();
      }
    },

    btnDelete: async function () {
      this.$refs.isModalAlertConfirm.hide();

      let resData = await this.$callApi(
        "delete",
        `${this.$baseUrl}/api/announcement/remove/${this.id}`,
        null,
        this.$headers,
        null,
      );
      this.modalMessage = resData.message;
      if (resData.result == 1) {
        this.$refs.modalAlert.show();
        setTimeout(() => {
          this.$router.push({
            path: `/announcement`,
          });
        }, 3000);
      } else {
        this.$refs.modalAlertError.show();
      }
    },
    openModalDelete(name) {
      this.modalMessage = "คุณต้องการลบ " + name + " ใช่หรือไม่?";
      this.$refs.isModalAlertConfirm.show();
    },
  },
};
</script>

<style scoped>
.panel {
  font-size: 17px;
  color: #16274a;
}
</style>
